import { ImageField, Field } from "@sitecore-jss/sitecore-jss-nextjs";
import { Box } from "@chakra-ui/react";

import SCImage from "components/sc/SCImage";
import SCText from "components/sc/SCText";

interface Fields {
    CaptionHeadline: Field<string>;
    CaptionText: Field<string>;
    Image: ImageField;
}

export type ImageProps = {
    params: { [key: string]: string };
    fields: Fields;
};

const ImageComponent = (props: ImageProps) => {
    return (
        <>
            <Box>
                <SCImage
                    width={Number(props.fields?.Image?.value?.width)}
                    height={Number(props.fields?.Image?.value?.height)}
                    quality={100}
                    imageField={props.fields?.Image}
                    sx={{
                        borderRadius: "base",
                        aspectRatio: "4/3",
                        objectFit: "cover",
                        width: "full",
                    }}
                />
            </Box>
            <Box mt="sp24" lineHeight="tall">
                <SCText textField={props.fields?.CaptionHeadline} size="imageCaptionHeadline" />
                <SCText size="bodySmall" textField={props.fields?.CaptionText} />
            </Box>
        </>
    );
};
export default ImageComponent;
